import { baseBUCGet, } from '../base/baseBUC';

const int = 0;
const str = '';
const decimal = 0.00;

export const apartmentModelGet = ({
    buildingId = '',
    floor = 0,
    userId = '',
}) => {
    return {
        aliquotPercentage: decimal,
        floor: floor,
        identifier: str,
        parkingPlace: int,
        phoneNumber: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    };
};